import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api phần user
export const getListReportQueryById = lst => {
    return api.makeAuthRequest({
        url: `/report/query/list?ids=${lst}`,
        method: 'GET',
    })
}
export const createNewReport = body => {
    return api.makeAuthRequest({
        url: `/report`,
        method: 'POST',
        data: body,
    })
}
export const sendReportToTask = id => {
    return api.makeAuthRequest({
        url: `/report/send/${id}`,
        method: 'POST',
    })
}
export const updateStatusReport = (report_id, status) => {
    return api.makeAuthRequest({
        url: `/report/updatestatus?report_id=${report_id}&status=${status}`,
        method: 'PUT',
    })
}
export const commentReport = body => {
    return api.makeAuthRequest({
        url: `/report/comment`,
        method: 'POST',
        data: body,
    })
}
export const getListReportComment = rid => {
    return api.makeAuthRequest({
        url: `/report/${rid}/comments`,
        method: 'GET',
    })
}
export const updateReportReworkAPI = (fid, body) => {
    return api.makeAuthRequest({
        url: `/report/${fid}`,
        method: 'PUT',
        data: body,
    })
}
export const updateScoreReport = (rid, score) => {
    return api.makeAuthRequest({
        url: `/report/updatescore?rid=${rid}&score=${score}`,
        method: 'PUT',
    })
}
